var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ChevronDownIconGlyph } from '@shapeable/icons';
import { Icon } from './icon';
var cls = classNames('content-reveal');
import AnimateHeight from 'react-animate-height';
export var ContentRevealDefaultProps = {
  expandIconComponent: ChevronDownIconGlyph,
  disclosureBackground: 'primary',
  disclosureIconColor: 'light',
  disclosureIconSize: 24,
  isExpanded: false,
  duration: 300,
  onChange: function () {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    background: ", ";\n  "], ["\n    color: ", ";\n    background: ", ";\n  "])), theme.COLOR('text'), theme.COLOR('app-chrome'))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    font-weight: 500;\n    \n    margin: 0;\n    cursor: pointer;\n\n    &:hover {\n      filter: brightness(1.05);\n      .", " {\n        filter: brightness(1.1);\n      }\n    }\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    font-weight: 500;\n    \n    margin: 0;\n    cursor: pointer;\n\n    &:hover {\n      filter: brightness(1.05);\n      .", " {\n        filter: brightness(1.1);\n      }\n    }\n  "])), cls.sub('button'))
});
var HeaderBodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    padding: ", ";\n  "])), theme.UNIT(4))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    align-self: stretch;\n    cursor: pointer;\n    padding: ", " ", ";\n    &:hover {\n      filter: brightness(1.1);\n    }\n    ", "\n  "], ["\n    ", ";\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    align-self: stretch;\n    cursor: pointer;\n    padding: ", " ", ";\n    &:hover {\n      filter: brightness(1.1);\n    }\n    ", "\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.UNIT(4), theme.UNIT(2), function (_a) {
    var disclosureBackground = _a.disclosureBackground,
      iconColor = _a.iconColor;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background: ", ";\n      ", ";\n    "], ["\n      background: ", ";\n      ", ";\n    "])), theme.COLOR(disclosureBackground), theme.FILL(iconColor));
  })
});
var DisclosureIconStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    transition: transform 0.3s;\n    ", "\n  "], ["\n    transition: transform 0.3s;\n    ", "\n  "])), function (_a) {
    var isExpanded = _a.isExpanded,
      useDisclosureRotation = _a.useDisclosureRotation;
    return useDisclosureRotation && isExpanded && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      transform: rotate(-180deg);\n    "], ["\n      transform: rotate(-180deg);\n    "])));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled.h2.attrs(cls.attr('header'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Icon: styled(Icon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  HeaderBody: styled.span.attrs(cls.attr('header-body'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), HeaderBodyStyles),
  Button: styled.button.attrs(cls.attr('button'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  DisclosureIcon: styled(Icon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), DisclosureIconStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var ContentReveal = function (props) {
  var className = props.className,
    children = props.children,
    header = props.header,
    onChange = props.onChange,
    disclosureBackground = props.disclosureBackground,
    expandIconComponent = props.expandIconComponent,
    collapseIconComponent = props.collapseIconComponent,
    disclosureIconSize = props.disclosureIconSize,
    duration = props.duration,
    disclosureIconColor = props.disclosureIconColor,
    isExpanded = props.isExpanded,
    iconSize = props.iconSize;
  var ExpandIcon = expandIconComponent;
  var CollapseIcon = collapseIconComponent;
  var useDisclosureRotation = !CollapseIcon;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Header, {
    onClick: onChange,
    className: cls.sub('header')
  }, React.createElement(My.HeaderBody, {
    className: cls.sub('header-body')
  }, header), React.createElement(My.Button, {
    className: cls.sub('button'),
    iconColor: disclosureIconColor,
    disclosureBackground: disclosureBackground,
    onClick: onChange
  }, React.createElement(My.DisclosureIcon, {
    useDisclosureRotation: useDisclosureRotation,
    isExpanded: isExpanded,
    size: disclosureIconSize
  }, !isExpanded || useDisclosureRotation ? React.createElement(ExpandIcon, null) : React.createElement(CollapseIcon, null)))), React.createElement(AnimateHeight, {
    duration: duration,
    height: isExpanded ? "auto" : 0
  }, React.createElement(My.Body, {
    className: cls.sub('body')
  }, children)));
};
ContentReveal.defaultProps = ContentRevealDefaultProps;
ContentReveal.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;